
import { Select } from 'antd'
import SetColor from '../setColor/index.jsx'
import './index.less'
import React from 'react'
console.log(React)

const { Option } = Select

export default function BasicsSide(props) {
  return (<div className='BasicsSide'>
    <h3 className='BasicsSide_title'>落地页基础设置</h3>
    {/* <div className='BasicsSide_item'>
      <span className='item_title'>落地页名称</span>
      <div className='item_main'>
        <div className='itme'>
          <Input showCount maxLength={20} value={props.sharingSettings.name} onChange={(e) => {
            props.sharingSettings.name = e.target.value
            props.setSharingSettings(props.sharingSettings)
          }} />
        </div>
      </div>
    </div>

    <div className='BasicsSide_item'>
      <span className='item_title'>落地页标题</span>
      <div className='item_main'>
        <div className='itme'>
          <Input showCount maxLength={20} value={props.sharingSettings.title} onChange={(e) => {
            props.sharingSettings.title = e.target.value
            props.setSharingSettings(props.sharingSettings)
          }} />
        </div>
      </div>
    </div>

    <div className='BasicsSide_item'>
      <span className='item_title'>微信公众号</span>
      <div className='item_main'>
        <div className='itme'>
          <Select placeholder='请输入公众号'
            showSearch
            bordered
            notFoundContent={'暂无数据'}
            style={{ width: '80%' }}
          >
            <Option>123</Option>
          </Select>
          <span className='item_tips'>刷新</span>
        </div>
      </div>
    </div> */}

    <div className='BasicsSide_item'>
      <span className='item_title'>落地页标题</span>

      <div className='text_box'>
        <input type='text' placeholder='落地页名称（用于管理）' className='TextInput' maxLength={20} value={props.sharingSettings.title} onChange={(e) => {
          props.sharingSettings.title = e.target.value
          props.setSharingSettings(props.sharingSettings)
        }} />
        <div className='text_number'>{props.sharingSettings.title.length}/20</div>
      </div>
    </div>

    <div className='BasicsSide_item'>
      <span className='item_title'>落地页名称</span>

      <div className='text_box'>
        <input type='text' placeholder='落地页名称（用于管理）' className='TextInput' maxLength={20} value={props.sharingSettings.name} onChange={(e) => {
          props.sharingSettings.name = e.target.value
          props.setSharingSettings(props.sharingSettings)
        }} />
        <div className='text_number'>{props.sharingSettings.name.length}/20</div>
      </div>
    </div>

    <div className='BasicsSide_item'>
      <span className='item_title'>微信公众号</span>
      <div className='item_main'>
        <div className='itme'>
          <Select placeholder='请输入公众号'
            showSearch
            bordered
            notFoundContent={'暂无数据'}
            style={{ width: '80%' }}
          >
            <Option>123</Option>
          </Select>
          <span className='item_tips'>刷新</span>
        </div>
      </div>
    </div>

    <div className='BasicsSide_item'>
      <span className='item_title'>背景颜色</span>
      <div className='item_mainB'>
        <div className='item'>
          <SetColor color={props.sharingSettings.back} setColor={(obj) => {
            props.sharingSettings.back = obj.hex
            props.setSharingSettings(props.sharingSettings)
          }}></SetColor>
        </div>
      </div>
    </div>
  </div>)
}
